import { Component, Inject, OnInit, Injector } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PractitionerService } from 'app/core/http/services/practitioner.service';
import { PractitionerSecretariesAffiliationService } from 'app/core/http/services/practititoner-secretaries-affiliation.service';
import { SecretaryService } from 'app/core/http/services/secretary.service';
import { DialogData } from 'app/core/interfaces/dialog';
import { organizationI } from 'app/core/interfaces/organization';
import { practitionerI } from 'app/core/interfaces/practitioner';
import { secretaryI } from 'app/core/interfaces/secretary';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { MaterialDialog } from 'app/modules/shared/components/dialog/dialog.component';

@Component({
  selector: 'page-practioner-registration',
  templateUrl: './practioner-registration.component.html',
  styleUrls: ['./practioner-registration.component.scss'],
})
export class PractionerSecretaryLinkComponent extends BaseComponent implements OnInit {
  public practitioners: any[] = [];
  public practitioner: practitionerI = <practitionerI>{};
  public secretary: secretaryI = <secretaryI>{};
  public search = '';
  public get practitionersFilter(): any[] {
    const practitioners = [...this.practitioners];
    return practitioners.filter(
      (item: any) =>
        (this.search == '' ||
          (item.name && item.name.indexOf(this.search) > -1) ||
          (item.address && item.address.city && item.address.city.indexOf(this.search) > -1)) &&
        this.currentUser.type == 'secretary' &&
        !this.secretary.practitioners?.includes(item.id as number) &&
        item.active == true
    );
  }

  public secretaryLogged: any = {};

  private practitionerRole: any[] = [];

  public affiliations: any[] = [];
  public refreshMainComponent: Boolean = false;

  constructor(
    public dialogRef: MatDialogRef<MaterialDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public practitionerService: PractitionerService,
    public affiliationService: PractitionerSecretariesAffiliationService,
    private injector: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {
    const secretary = this.getUserLogged();

    this.secretaryLogged = {
      secretary_id: secretary.id,
      name: secretary.name,
    };

    if (this.data.param.practitionerRole) {
      this.affiliations = this.data.param.affiliations;
      this.practitionerRole = this.data.param.practitionerRole;
    }

    this.getPractitioners();
  }

  getPractitioners() {
    this.practitionerService.list().subscribe({
      next: (resPractioner: any) => {
        const affiliations = this.affiliations.filter((affiliation) => affiliation.status == 'requested' || affiliation.status == 'accepted');
        const practitionerIdInAffiliation = affiliations.map((affiliation) => affiliation.practitioner_id);

        this.practitioners = resPractioner.filter((affiliation: any) => !practitionerIdInAffiliation.includes(affiliation.practitioner_id));
      },
      error: (err) => {
        console.log('Falha ao buscar medicos', err);
      },
    });
  }

  getRole(practitioner: any) {
    return this.practitionerRole.find((registro) => registro.practitioner_id == 'c86b2339-41da-4e91-9ddd-c0edee6a5911');
  }

  getSpecialization(practitioner: any) {
    return 'Cardiologista';

    const role = this.getRole(practitioner);

    if (!role) return '';
    return role.speciality;
  }

  getCity(practioner: any) {
    return practioner?.address[0]?.city || null;
  }

  openDetails(practitioner: practitionerI) {
    this.dialog.openPractitionerDetailDialog({
      title: practitioner.name,
      component: 'practitioner-detail',
      param: { id: practitioner.id },
    });
  }

  public transformObjectToFHIR(data: any) {
    console.log('practitioner', data);

    const transformedData = {
      resourceType: 'Affiliation',
      affiliation_id: data.practitioner_id,
      request: {
        id: data.secretary_id,
        referenceType: 'Secretaries',
        display: data.name,
      },
      subject: {
        id: data.practitioner_id,
        referenceType: 'Organization',
        display: data.practitioner_name,
      },
      status: 'requested',
      requestDateTime: data.requestDateTime,
      updateDateTime: data.updateDateTime,
    };

    return transformedData;
  }

  linkWithSecretary(practitioner: any) {
    const practitionerAffiliation = {
      practitioner_id: practitioner.practitioner_id,
      practitioner_name: practitioner.name,
    };

    const currentDate = new Date().toISOString();

    const affiliation = {
      ...practitionerAffiliation,
      ...this.secretaryLogged,
      requestDateTime: currentDate,
      updateDateTime: currentDate,
    };

    const afffiliationFHIR = this.transformObjectToFHIR(affiliation);

    this.affiliationService.create(afffiliationFHIR).subscribe({
      next: (resAffiliation) => {
        practitioner.isHidden = true;
        this.refreshMainComponent = true;

        this.openSnackBar('Afiliação ao especialista solicitado com sucesso', 'success');
      },
      error: (err) => {
        console.log('ERRO', err);
      },
    });
  }

  openPractitionerForm() {
    this.dialog.openRegisterFormDialog({
      title: 'Cadastrar novo especialista',
      param: { type: 'practitioner' },
    });
  }
}
